import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { VeldaCountry } from 'src/app/models/VeldaCountry';
import { VeldaLanguageDTO } from 'src/app/models/VeldaLanguageDTO';

import { AddLanguage } from '../velda-languages.actions';
import { VeldaLanguagesState } from '../velda-languages.state';

@Component({
    selector: 'app-velda-languages-languages-add-modal',
    templateUrl: './velda-languages-languages-add-modal.component.html',
    styleUrls: ['./velda-languages-languages-add-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class VeldaLanguagesLanguagesAddModalComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(VeldaLanguagesState.countries) countries$: Observable<VeldaCountry[]>;

    countries: VeldaCountry[];
    languageFormGroup: UntypedFormGroup;
    countryKeyword = 'countryName';
    loading = true;

    constructor(
        private store: Store,
        public activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
        private toastrService: ToastrService,
        private logger: NGXLogger,
    ) {}

    ngOnInit(): void {
        this.subscriptions.add(
            this.countries$.subscribe((countries) => {
                this.countries = countries;

                this.languageFormGroup = this.formBuilder.group({
                    languageName: ['', [Validators.required]],
                    languageCode: ['', [Validators.required]],
                    country: ['', [Validators.required]],
                });

                this.loading = false;
            }),
        );
    }

    addLanguage() {
        const veldaLanguage: VeldaLanguageDTO = {
            languageName: this.languageFormGroup.value.languageName,
            languageCode: this.languageFormGroup.value.languageCode,
            countryUuid: this.languageFormGroup.value.country.uuid,
        };

        this.logger.debug('Attempt to add language');

        this.subscriptions.add(
            this.store.dispatch(new AddLanguage(veldaLanguage)).subscribe(
                () => {
                    this.toastrService.success('Language added successfully!');
                    this.logger.debug('Language added successfully!');
                    this.activeModal.close();
                },
                (error) => {
                    this.toastrService.error('Failed to add Language!');
                    this.logger.error('Failed to add Language!');
                },
            ),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
